import PropTypes from 'prop-types';

import { Panel } from '../Panels';

import './styles/sideNavigationStyles.css';

const SideNavigation = ({ ariaLabel, children }) => {
  return (
    <nav aria-label={ariaLabel}>
      <div className="overflow-y-auto max-h-3/4">
        <Panel>{children}</Panel>
      </div>
    </nav>
  );
};

SideNavigation.propTypes = {
  /**
   * ARIA label for the overall navigation
   */
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default SideNavigation;
